import { isString } from './string';

export function raise(error: unknown): never;
export function raise(message: string): never;
export function raise(messageOrError: unknown | string): never {
  if (isString(messageOrError)) {
    throw new Error(messageOrError);
  }

  throw messageOrError;
}

export function isError(error: unknown): error is Error {
  return error instanceof Error;
}

export function validateError(error: unknown): asserts error is Error {
  if (!isError(error)) {
    raise('Error is not defined');
  }
}

export function raiseUnreachable(unreachableType: never): never {
  raise(`Unreachable type: ${unreachableType}`);
}
